import { combineReducers } from 'redux'

import customersReducer from './customers'
import answersReducer from './answers'
import answerDetailsReducer from './answer_details'
import userInfoReducer, * as userInfoSelectors from './userInfo'
import integrationsReducer, * as integrationsSelectors from './integrations'
import surveysReducer, * as surveySelectors from './surveys'
import feedbackFilterReducer from './feedbackFilter'
import customerReducer, * as customerSelectors from './customer'
import customerFilterReducer from './customerFilter'
import emailSubscriptionReducer, * as emailSubscriptionSelectors from './emailSubscription'
import emailSurveySubscriptionReducer, * as emailSurveySubscriptionSelectors from './emailSurveySubscription'
import userReducer, * as userSelectors from './user'
import cardReducer from './card'
import subscriptionReducer from './subscription'
import connectwiseReducer from './connectwise'
import surveyEmailDeliverySettingReducer from './surveyEmailDeliverySetting'

export default combineReducers({
  customers: customersReducer, // Delete this later
  answers: answersReducer,
  answer_details: answerDetailsReducer,
  userInfo: userInfoReducer,
  integrations: integrationsReducer,
  surveys: surveysReducer,
  feedbackFilter: feedbackFilterReducer,
  customerFilter: customerFilterReducer,
  emailSubscription: emailSubscriptionReducer,
  emailSurveySubscription: emailSurveySubscriptionReducer,
  user: userReducer,
  customer: customerReducer,
  card: cardReducer,
  subscription: subscriptionReducer,
  connectwise: connectwiseReducer,
  surveyEmailDeliverySetting: surveyEmailDeliverySettingReducer,
})

export const getCompanyId = (state) => userInfoSelectors.getCompanyId(state.userInfo)

export const getFeedbackFilter = (state) => state.feedbackFilter

export const getCustomerFilter = (state) => state.customerFilter

export const getIsZendeskIntegrationActive = (state) =>
  integrationsSelectors.getIsZendeskIntegrationActive(state.integrations)

export const getIsConnectwiseIntegrationActive = (state) =>
  integrationsSelectors.getIsConnectwiseIntegrationActive(state.integrations)

export const getAutotaskCredential = (state, surveyToken) =>
  integrationsSelectors.getAutotaskCredential(state.integrations, surveyToken)

export const getIsAutotaskIntegrationActive = (state, surveyToken) =>
  integrationsSelectors.getIsAutotaskIntegrationActive(state.integrations, surveyToken)

export const getIsSatisfactionRatingBackwardSyncActive = (state, surveyId) =>
  surveySelectors.getIsSatisfactionRatingBackwardSyncActive(state.surveys, surveyId)

export const getSurveySettingsFromId = (state, surveyId) =>
  surveySelectors.getSurveySettingsFromId(state.surveys, surveyId)

export const getSurveyFromId = (state, surveyId) =>
  surveySelectors.getSurveyFromId(state.surveys, surveyId)

export const getSurveyNameFromToken = (state, surveyToken) =>
  surveySelectors.getSurveyNameFromToken(state.surveys, surveyToken)

export const getSurveyFromToken = (state, surveyToken) =>
  surveySelectors.getSurveyFromToken(state.surveys, surveyToken)

export const getSurveyTokenFromId = (state, surveyId) =>
  surveySelectors.getSurveyTokenFromId(state.surveys, surveyId)

export const getSurveyTypeFromId = (state, surveyId) =>
  surveySelectors.getSurveyTypeFromId(state.surveys, surveyId)

export const hasSurveyByType = (state, surveyType) =>
  surveySelectors.hasSurveyByType(state.surveys, surveyType)

export const getAllSurveys = (state) => surveySelectors.getAllSurveys(state.surveys)

export const getNotificationFrequency = (state) =>
  emailSubscriptionSelectors.getNotificationFrequency(state.emailSubscription)

export const getEmailSubscriptionId = (state) =>
  emailSubscriptionSelectors.getEmailSubscriptionId(state.emailSubscription)

export const getEmailSurveySubscriptionIds = (state) =>
  emailSubscriptionSelectors.getEmailSurveySubscriptionIds(state.emailSubscription)

export const getEmailSurveySubscription = (state, ids) =>
  emailSurveySubscriptionSelectors.getEmailSurveySubscription(state.emailSurveySubscription, ids)

export const getUsers = (state, currentUserId) => userSelectors.getUsers(state.user, currentUserId)

export const getCurrentUserId = (state) => userInfoSelectors.getCurrentUserId(state.userInfo)

export const getCurrentUserFullName = (state) =>
  userInfoSelectors.getCurrentUserFullName(state.userInfo)

export const getCurrentUserEmail = (state) => userInfoSelectors.getCurrentUserEmail(state.userInfo)

export const getCustomerEntities = (state) => customerSelectors.getCustomerEntities(state.customer)

export const getCustomer = (state, customerId) =>
  customerSelectors.getCustomer(state.customer, customerId)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/data/index.js